<script lang="ts">
	import { useDialog } from "@components/utils/useDialog";

	const { target, component } = useDialog();

	//daisy-modal-box
</script>

<dialog bind:this={$target} class="daisy-modal">
	<svelte:component this={$component} />
</dialog>
